import { SignupHeaderLogic } from './SignupHeader'
import { TypographyStyles } from '@/styles'
import { Alert, Button, Image, Text } from '@/ui'

export const DesktopHeader = ({
  loggedIn,
  handleLogoutClick,
  currentStep,
  reactivating,
  hideProgress,
}: {
  loggedIn: boolean
  handleLogoutClick: () => void
  currentStep: number
  reactivating: boolean
  hideProgress?: boolean
}) => {
  return (
    <>
      <div className="flex items-center justify-between pb-0">
        <Image
          src="https://heard-images.s3.us-west-1.amazonaws.com/heard_logo_green_2x.png"
          alt="heard logo"
          height={20}
          width={20}
        />

        {loggedIn && (
          <Button variant="link" onClick={() => handleLogoutClick()}>
            Logout
          </Button>
        )}
      </div>

      {!hideProgress && <SignupHeaderLogic currentStep={currentStep} />}

      {reactivating && (
        <Alert>
          <Text variant={TypographyStyles.BODY_LG}>Welcome back to Heard!</Text>

          <Text variant={TypographyStyles.BODY_LG}>
            To reactivate your account, please proceed through the sign up flow.
          </Text>
        </Alert>
      )}
    </>
  )
}
